import { PoinzApiClient } from 'api';
import { PartnerContactForm } from './types/partnerContact';

const ROOT = '/v2/partner-contact';
const post =
  (apiClient: PoinzApiClient) =>
  async (partnerContactForm: PartnerContactForm): Promise<void> => {
    const response = await apiClient.post(`${ROOT}`, {
      body: partnerContactForm
    });
    return response.body;
  };

export default (apiClient: PoinzApiClient) => ({
  post: post(apiClient)
});
